"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushEvents = flushEvents;
const utils_1 = require("@aws-amplify/core/internals/utils");
const core_1 = require("@aws-amplify/core");
const utils_2 = require("../utils");
const utils_3 = require("../../../utils");
const logger = new core_1.ConsoleLogger('Personalize');
function flushEvents(...args) {
    const [ctx] = (0, utils_1.resolveCtxArgs)(args);
    const { region, flushSize, bufferSize, flushInterval } = (0, utils_2.resolveConfig)(ctx);
    (0, utils_3.resolveCredentials)(ctx)
        .then(({ credentials, identityId }) => (0, utils_2.getEventBuffer)({
        region,
        flushSize,
        flushInterval,
        bufferSize,
        credentials,
        identityId,
        userAgentValue: (0, utils_3.getAnalyticsUserAgentString)(utils_1.AnalyticsAction.Record),
    }))
        .then(eventBuffer => eventBuffer.flushAll())
        .catch(e => {
        logger.warn('Failed to flush events', e);
    });
}
